

import React from 'react'
import { object } from 'prop-types'

class appDownload extends React.Component {

  render () {
    const { agentData } = this.props
    return (
      <div className='appDownload'>
        <a href={'https://itunes.apple.com/gb/app/holiday-extras-we-take-hassle/id783591488?mt=8&ign-mpt=uo%3D4&agent=' + agentData.agent} target='_blank'>
          <img src='https://dmy0b9oeprz0f.cloudfront.net/holidayextras.co.uk/pages/content/btn-apple-store.png' width='200' alt='Apple Download' />
        </a>
        <a href={'https://play.google.com/store/apps/details?id=com.HolidayExtras.Tripapp&amp;referrer=utm_source%3Dinfo%26utm_medium%3Dwebsite%26utm_campaign%3Dinfosite&agent=' + agentData.agent} target='_blank'>
          <img src='https://dmy0b9oeprz0f.cloudfront.net/holidayextras.co.uk/pages/content/btn-google-play.png' width='200' alt='Android Download' />
        </a>
      </div>
    )
  }
}

appDownload.propTypes = {
  agentData: object
}

export default appDownload



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/content/appDownload.jsx